// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2_42b","button":"styles_button__1jD3X"};